import React from 'react';
import PropTypes from 'prop-types';

import LazyLoadTransition from '../../../components/LazyLoadTransition/LazyLoadTransition';

const SponsorPart = ({ imgs, title }) => (
  <div className="container">
    <LazyLoadTransition>
      <h1 className="section-title">{title}</h1>
      <div className="columns is-variable is-mobile is-multiline">
        {imgs.map(
          ({
            alt,
            classes,
            url,
            src,
            imgWidthLarge,
            imgWidthDesktop,
            imgWidthTablet,
            imgWidthMobile
          }) => (
            <div
              key={alt}
              className={`column ${classes}`}
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}>
              <a
                className="is-hidden-touch is-hidden-desktop-only"
                href={url}
                rel="noopener noreferrer"
                style={{
                  width: imgWidthLarge,
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center'
                }}
                target="_blank">
                <img alt={alt} src={src} />
              </a>
              <a
                className="is-hidden-touch is-hidden-widescreen"
                href={url}
                rel="noopener noreferrer"
                style={{
                  width: imgWidthDesktop,
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center'
                }}
                target="_blank">
                <img alt={alt} src={src} />
              </a>
              <a
                className="is-hidden-mobile is-hidden-desktop"
                href={url}
                rel="noopener noreferrer"
                style={{
                  width: imgWidthTablet,
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center'
                }}
                target="_blank">
                <img alt={alt} src={src} />
              </a>
              <a
                className="is-hidden-tablet"
                href={url}
                rel="noopener noreferrer"
                style={{
                  width: imgWidthMobile,
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center'
                }}
                target="_blank">
                <img alt={alt} src={src} />
              </a>
            </div>
          )
        )}
      </div>
    </LazyLoadTransition>
  </div>
);

export default SponsorPart;

SponsorPart.propTypes = {
  imgs: PropTypes.arrayOf(PropTypes.objectOf(PropTypes.string)).isRequired,
  title: PropTypes.string.isRequired
};
